<section
  class="cotizador-cotizacion-page">
  <ng-container *ngFor="let item of resumenProgramas; trackBy: trackByProgramaId">
    <app-resumen-cotizacion-programa
      [programaId]="item.programaId"
      [cargaRevision]="cargaRevision"
      [lineaNegocio]="item.lineaNegocio"
      [programaTitulo]="item.programaTitulo"
      [rowsData]="item.rows"
      [estadoInicial]="estadoInicialPorPrograma.get(item.programaId)"
      [bloqueoInteraccion]="bloqueoInteraccionCotizacion"
      (estadoLiqudacionChange)="onEstadoLiquidacionProgramaChange($event)"
      (calculoPendienteChange)="onCalculoPendienteProgramaChange($event)">
    </app-resumen-cotizacion-programa>
  </ng-container>
</section>

<div class="cotizador-actions">
  <button type="button" class="btn-action btn-limpiar" [disabled]="!camposCompletosMock || cargandoUltimaPantalla || deshabilitadoPorVersionHistorica || procesandoCotizacion || guardandoEnCurso || bloqueoPostGuardadoExitoso" (click)="guardar()">
    GUARDAR
  </button>
  <button type="button" class="btn-action btn-consultar btn-enviar" [disabled]="!camposCompletosMock || cargandoUltimaPantalla || !guardadoExitoso || deshabilitadoPorVersionHistorica" (click)="descargarPDFDesdeDatos()">
    {{ procesandoCotizacion ? 'PROCESANDO...' : 'DESCARGAR COTIZACIÓN' }}
  </button>
  <button type="button" class="btn-action btn-consultar" (click)="salirCotizador()">
    SALIR
  </button>
</div>
